import React from "react";
import { useEffect } from "react";

const WidgetTime = ({ timer, setTimer }) => {
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer(timer - 1);
    }, 1000);

    return () => clearInterval(interval);
  });
  return (
    <div>
      <h4>Refreshing In {timer}s</h4>
    </div>
  );
};

export default WidgetTime;
